import EstensaModel, { BrokerDataExam, BrokerSettings } from 'estensa-module';


export function convertStudiesToPacsData(studies: EstensaModel.BrokerDataStudy[]) {
    let pacsStudyDataList = new Array<EstensaModel.PacsStudyData>();
    studies.forEach((brokerStudyData) => {
        let pacsStudyData = new EstensaModel.PacsStudyData();
        pacsStudyData.setByBrokerDataStudy(brokerStudyData);
        pacsStudyDataList.push(pacsStudyData);
    });

    return pacsStudyDataList;
}

export function checkPresExams(params: EstensaModel.BrokerCheckParams, exams: EstensaModel.BrokerDataExam[]): boolean {
    const bPresFound: boolean = exams.some((currExam) => {
        return params.idPresList.includes(currExam.idExam.toLowerCase() || currExam.idExam.toUpperCase());
    });
    return bPresFound;
}


// BROKER CHECK
export function checkSuspectStudies(
    params: EstensaModel.BrokerCheckParams,
    studies: EstensaModel.BrokerDataStudy[],
    exams: EstensaModel.BrokerDataExam[],
) {
    let displayData : EstensaModel.BrokerDataDisplay[] = [];
    params.idPresList.forEach((idPres: string) => {
        let currentExams = exams.filter((exam) => {
            return (exam.idExam == idPres.toLowerCase() || exam.idExam == idPres.toUpperCase());
        });
        let currentStudies = studies.filter((study) => {
            return (study.idExam == idPres.toLowerCase() || study.idExam == idPres.toUpperCase()) && study.suspect == true;
        });
        if (currentExams.length > 0 && currentStudies.length > 0) {
            currentExams.forEach((currExam: BrokerDataExam) => {
                let displayExam = new EstensaModel.BrokerDataDisplay();
                displayExam.setByExam(currExam);
                displayData.push(displayExam);
            });

            currentStudies.forEach((currStudy) => {
                let displayStudy = new EstensaModel.BrokerDataDisplay();
                displayStudy.setByStudy(currStudy);
                displayData.push(displayStudy);
            });
        }
    });

    return displayData;
}

export function checkModifiedStudies(
    params: EstensaModel.BrokerCheckParams,
    studies: EstensaModel.BrokerDataStudy[],
    exams: EstensaModel.BrokerDataExam[],
) {
    let displayData : EstensaModel.BrokerDataDisplay[] = [];
    params.idPresList.forEach((idPres : string) => {
        let currentExams = exams.filter((exam) => {
            return (exam.idExam == idPres.toLowerCase() || exam.idExam == idPres.toUpperCase());
        });
        let currentStudies = studies.filter((study) => {
            return (study.idExam == idPres.toLowerCase() || study.idExam == idPres.toUpperCase()) && study.modified == true;
        });
        if (currentExams.length > 0 && currentStudies.length > 0) {
            currentExams.forEach((currExam) => {
                let displayExam = new EstensaModel.BrokerDataDisplay();
                displayExam.setByExam(currExam);
                displayData.push(displayExam);
                currentStudies.forEach((currStudy) => {
                    let displayStudy = new EstensaModel.BrokerDataDisplay();
                    displayStudy.setByStudy(currStudy);
                    displayData.push(displayStudy);
                });
            });
        }
    });
    return displayData;
}

export function checkDifferentData(
    params: EstensaModel.BrokerCheckParams,
    studies: EstensaModel.BrokerDataStudy[],
    exams: EstensaModel.BrokerDataExam[],
    brokerSettings: BrokerSettings | undefined,
) {
    if (params?.idPresList?.length) {
        let displayData : EstensaModel.BrokerDataDisplay[] = [];
        params?.idPresList?.forEach((idPres : string) => {
            let currentExams = exams.filter((exam) => {
                return (exam.idExam == idPres.toLowerCase() || exam.idExam == idPres.toUpperCase());
                 //exam.idExam == idPres;
            });
            let currentStudies = studies.filter((study) => {

                return (study.idExam == idPres.toLowerCase() || study.idExam == idPres.toUpperCase())
                 //study.idExam == idPres;
            });

            if (currentExams.length > 0 && currentStudies.length > 0) {
                currentExams.forEach((currExam) => {
                    let firstExamDiff: boolean = true;

                    currentStudies.forEach((currStudy) => {
                        let diffData = differentData(currExam, currStudy, brokerSettings as BrokerSettings);
                        if (diffData) {
                            if (firstExamDiff) {
                                let displayExam = new EstensaModel.BrokerDataDisplay();
                                displayExam.setByExam(currExam);
                                displayData.push(displayExam);
                                firstExamDiff = false;
                            }

                            displayData.push(diffData);
                        }
                    });
                });
            }
        });
        return displayData;
    }
}

export function differentData(
    exam: EstensaModel.BrokerDataExam,
    study: EstensaModel.BrokerDataStudy,
    brokerSettings: BrokerSettings,
): EstensaModel.BrokerDataDisplay | null {
    let isDifferent = false;
    let displayData = new EstensaModel.BrokerDataDisplay();
    displayData.setByStudy(study);

    if (study.patientInfo.dataNascita) {
        if (typeof study.patientInfo.dataNascita == 'string') {
            displayData.patientBirthDateFormatted = new Date(study.patientInfo.dataNascita.toString())
                .toISOString()
                .split('T')[0];
        } else {
            displayData.patientBirthDateFormatted = (study.patientInfo.dataNascita as Date).toISOString().split('T')[0];
        }
    }
    if (brokerSettings.isTypeAssociation != EstensaModel.BrokerAssociationType.SenzaAnagrafica) {
        if (study.patientInfo.cognome.toLowerCase() != exam.patientInfo.cognome.toLowerCase()) {
            isDifferent = true;
            displayData.patientInfo.cognome += ' *';
        }

        if (study.patientInfo.nome.toLowerCase() != exam.patientInfo.nome.toLowerCase()) {
            isDifferent = true;
            displayData.patientInfo.nome += ' *';
        }

        if (study.patientInfo.dataNascita != exam.patientInfo.dataNascita) {
            isDifferent = true;
            displayData.patientBirthDateFormatted += ' *';
        }

        if (study.patientInfo.sesso != exam.patientInfo.sesso) {
            isDifferent = true;
            displayData.patientInfo.sesso += ' *';
        }
    }
    if (isDifferent) {
        return displayData;
    }

    return null;
}



